<template>
  <user-login-wrapper>
    <el-card class="full-card" shadow="always">
      <template #header>
        <div v-if="detail != null">
          <jr-applicant-title
            titleName="協議要否判断"
            :applicantNumber="detail.applicant_number"
            :applicantTitle="detail.applicant_title"
          />
        </div>
      </template>
      <template #default>
        <double-scroll>
          <template #left>
            <proximity-info
              v-if="requestHeaderId"
              :isEdit="false"
              :requestHeaderId="requestHeaderId"
              @update:form="detail = $event"
              :returnToList="false"
              :isActionBtnVisible="true"
            />
          </template>
          <template #right>
            <!-- フッター -->
            <div class="footer-wrapper">
              <div class="footer">
                <el-row class="double-scroll-padding">
                  <el-col :span="24" class="align-right">
                    <!-- 協議要否決定ボタン -->
                    <judge-discussion-send
                      :proximityJudgeDiscussion="form"
                      :formRef="formRef"
                      :requestHeaderId="requestHeaderId"
                      :proximityId="detail.proximity.proximity_id"
                      v-if="detail != null && requestHeaderId"
                    />
                  </el-col>
                </el-row>
              </div>
            </div>
            <!-- 協議要否判断 -->
            <el-form
              :model="form"
              :rules="proximityRule"
              ref="formRef"
              class="right-panels double-scroll-padding"
              v-if="detail != null && requestHeaderId"
            >
              <input-group-dark title="協議要否判断">
                <el-row class="input-row">
                  <el-col :span="4" class="align-middle text-xs">
                    <input-label :required="true">協議要否</input-label>
                  </el-col>
                  <el-col :span="20" class="text-xs">
                    <el-form-item prop="judge_discussion_status" class="judge_discussion_status">
                      <jr-radio-group
                        v-model="form.judge_discussion_status"
                        :labels="[
                          { value: P_JD_DONE, text: '必要' },
                          { value: P_JD_NONE, text: '不要' },
                        ]"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="input-row" align="middle">
                  <el-col :lg="2" :span="3" :offset="4" class="text-xs">
                    <input-label>事前協議</input-label>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      prop="is_judge_discussion_prior_discussion_unneeded"
                      class="is_judge_discussion_prior_discussion_unneeded"
                    >
                      <jr-checkbox
                        v-model="form.is_judge_discussion_prior_discussion_unneeded"
                        :disabled="isJDCheckBoxDisabled"
                        >不要</jr-checkbox
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="input-row" align="middle">
                  <el-col :lg="2" :span="3" :offset="4" class="text-xs">
                    <input-label>現地立会</input-label>
                  </el-col>
                  <el-col :span="6">
                    <jr-checkbox
                      v-model="form.is_judge_discussion_witness_unneeded"
                      :disabled="isJDCheckBoxDisabled"
                      class="is_judge_discussion_witness_unneeded"
                      >不要</jr-checkbox
                    >
                  </el-col>
                </el-row>
                <el-row class="mt-5">
                  <el-col class="text-xs">
                    <input-label>備考欄</input-label>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item prop="judge_discussion_remark" class="judge_discussion_remark">
                      <jr-textarea :rows="10" v-model="form.judge_discussion_remark" size="small" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </input-group-dark>
            </el-form>
          </template>
        </double-scroll>
      </template>
    </el-card>
  </user-login-wrapper>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, watch, computed, ComputedRef, Ref } from 'vue'
import { ElForm } from 'element-plus'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import InputGroupDark from '@/components/layout/InputGroupDark.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'
import ProximityInfo from '@/components/layout/ProximityInfo.vue'
import { useRoute, useRouter } from 'vue-router'
import Logger from '@/services/logger'
import { RequestHeaderProximityForm } from '@/types/forms'
import { ProximityJudgeDiscussion } from '@/api'
import { proximityRule } from '@/constants/rules'
import JudgeDiscussionSend from '@/components/actions/JudgeDiscussionSend.vue'
import { P_JD_DONE, P_JD_NONE } from '@/constants/statuses'
import InputLabel from '@/components/inputs/InputLabel.vue'
import JrTextarea from '@/components/jr-parts/JrTextarea.vue'
import JrRadioGroup from '@/components/jr-parts/JrRadioGroup.vue'
import JrApplicantTitle from '@/components/jr-parts/JrApplicantTitle.vue'
import JrCheckbox from '@/components/jr-parts/JrCheckbox.vue'

export default defineComponent({
  components: {
    JudgeDiscussionSend,
    InputGroupDark,
    UserLoginWrapper,
    ProximityInfo,
    DoubleScroll,
    InputLabel,
    JrTextarea,
    JrRadioGroup,
    JrApplicantTitle,
    JrCheckbox,
  },
  setup() {
    const form = reactive<ProximityJudgeDiscussion>({})
    const formRef = ref<InstanceType<typeof ElForm>>()
    const route = useRoute()
    const router = useRouter()
    const detail = ref<RequestHeaderProximityForm | null>(null)
    const requestHeaderId = computed((): number => {
      return Number(route.params.request_header_id)
    })
    const isJDCheckBoxDisabled = computed((): boolean => {
      return !(form.judge_discussion_status === P_JD_DONE)
    })

    watch(
      () => detail.value,
      () => {
        service.asyncForm(form, detail)
      }
    )

    // ロジッククラス
    const service = (function () {
      const module = {
        ENUM: {
          PROXIMITY_JUDGE_DISCUSSION_STATUS: {
            P_JD_DONE,
            P_JD_NONE,
            P_JD_UNSELECTED: -1,
          },
          PROXIMITY_JUDGE_DISCUSSION_REMARK_INIT: '', //要否判断備考初期値
        },
        methods: function () {
          const ENUM = this.ENUM
          return {
            /**
             * 読み込み時処理
             * @param requestHeaderId ComputedRef<number>
             * @return void
             */
            load: (requestHeaderId: ComputedRef<number>): void => {
              if (Number.isNaN(requestHeaderId.value)) {
                Logger.info('申請基本IDが正しくない')
                router.push({ name: 'NotFound' })
              }
            },
            /**
             * フォーム同期
             * @param proximity ProximityJudgeDiscussion
             * @param requestHeaderDetail RequestHeaderProximityForm
             */
            asyncForm: function () {
              const status = ENUM.PROXIMITY_JUDGE_DISCUSSION_STATUS
              return {
                main: function (
                  proximity: ProximityJudgeDiscussion,
                  requestHeaderDetail: Ref<RequestHeaderProximityForm | null>
                ) {
                  if (!requestHeaderDetail.value?.proximity) {
                    return
                  }
                  const originProximity = requestHeaderDetail.value.proximity
                  // 要否判断ステータス
                  this.asyncJudgeDiscussionStatus(proximity, originProximity.judge_discussion_status)
                  // 要否判断事前協議不要フラグ
                  proximity.is_judge_discussion_prior_discussion_unneeded =
                    originProximity.is_judge_discussion_prior_discussion_unneeded
                      ? originProximity.is_judge_discussion_prior_discussion_unneeded
                      : false
                  // 要否判断現地立会不要フラグ
                  proximity.is_judge_discussion_witness_unneeded = originProximity.is_judge_discussion_witness_unneeded
                    ? originProximity.is_judge_discussion_witness_unneeded
                    : false
                  // 要否判断備考
                  proximity.judge_discussion_remark = originProximity.judge_discussion_remark
                    ? originProximity.judge_discussion_remark
                    : ENUM.PROXIMITY_JUDGE_DISCUSSION_REMARK_INIT
                },
                // 要否判断ステータス同期
                asyncJudgeDiscussionStatus: (
                  proximity: ProximityJudgeDiscussion,
                  judgeDiscussionStatus: number | undefined
                ): void => {
                  // 要否判断が要の場合、ラジオボタンの初期値を「必要」とする
                  if (judgeDiscussionStatus === status.P_JD_DONE) {
                    proximity.judge_discussion_status = status.P_JD_DONE
                    return
                  }
                  // 要否判断が不要の場合、ラジオボタンの初期値を「不要」とする
                  if (judgeDiscussionStatus === status.P_JD_NONE) {
                    proximity.judge_discussion_status = status.P_JD_NONE
                    return
                  }
                  // 要否判断が判断前または伺い中の場合、ラジオボタンの初期値を未選択とする
                  proximity.judge_discussion_status = status.P_JD_UNSELECTED
                },
              }
            },
          }
        },
      }
      return {
        // アクセス可能なメソッド
        load: (requestHeaderId: ComputedRef<number>): void => {
          module.methods().load(requestHeaderId)
        },
        asyncForm: (form: ProximityJudgeDiscussion, detail: Ref<RequestHeaderProximityForm | null>): void => {
          module.methods().asyncForm().main(form, detail)
        },
      }
    })()

    // 初期処理
    service.load(requestHeaderId)
    return {
      form,
      formRef,
      detail,
      requestHeaderId,
      proximityRule,
      P_JD_DONE,
      P_JD_NONE,
      isJDCheckBoxDisabled,
    }
  },
})
</script>
<style lang="scss" scoped>
.el-form {
  margin-bottom: 50px;
}
</style>
